<div class="sammel-dialog">
  <div class="sammel-header">
    <h2 mat-dialog-title>Sammelstelle</h2>
    <button mat-icon-button type="button" class="sammel-close" (click)="close()" aria-label="Schließen">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div *ngIf="!allowed" class="sammel-denied" mat-dialog-content>
    <p *ngIf="!roleAllowed">Keine Berechtigung für Sammelstelle (Benutzerrolle erforderlich).</p>
    <p *ngIf="roleAllowed && !betriebAllowed">
        Sammelstelle gibt es nur, wenn ein Betrieb der Betriebsart Sammelstelle ausgewählt ist.
    </p>
    <button mat-stroked-button type="button" (click)="close()">Schließen</button>
  </div>

  <ng-container *ngIf="allowed">
    <div mat-dialog-content class="sammel-content">
      <div class="sammel-toolbar">
        <mat-form-field appearance="outline" class="toolbar-field scan-field" floatLabel="always">
          <mat-label>Scan (10 / 15)</mat-label>
          <input
            #scanInput
            matInput
            [(ngModel)]="scanText"
            (ngModelChange)="onScanInput($event)"
            (keydown.enter)="onScanEnter($event)"
            autocomplete="off"
            autofocus
          />
          <mat-icon matSuffix class="scan-suffix-icon" (click)="focusScan()">qr_code_scanner</mat-icon>
        </mat-form-field>

        <div class="ohrmarke-info" aria-live="polite">
          <span class="ohrmarke-info__label">Ohrmarke</span>
          <span class="ohrmarke-info__value">{{ ohrmarkeDisplay }}</span>
        </div>

        <mat-form-field appearance="outline" class="toolbar-field ziel-field" floatLabel="always">
          <mat-label>Zielgruppe</mat-label>
          <mat-select
            [value]="zielGruppe?.gruppe_id"
            (selectionChange)="onZielgruppeChange($event.value)"
          >
            <mat-option [value]="null">—</mat-option>
            <mat-option *ngFor="let g of gruppen" [value]="g.gruppe_id">
              {{ g.gruppe_nr_intern || g.gruppe_id }} {{ g.bezeichnung }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <ng-container *ngIf="einstalldatumLocked; else datumEdit">
          <div class="einstalldatum-info">
            <div class="einstalldatum-info__text">
              <span class="einstalldatum-info__label">Einstalldatum</span>
              <span class="einstalldatum-info__value">{{ einstalldatumDisplay }}</span>
            </div>
            <button
              mat-icon-button
              type="button"
              class="einstalldatum-info__edit"
              aria-label="Einstalldatum ändern"
              matTooltip="Einstalldatum ändern"
              (click)="unlockEinstalldatum()"
            >
              <mat-icon>edit</mat-icon>
            </button>
          </div>
        </ng-container>
        <ng-template #datumEdit>
          <mat-form-field appearance="outline" class="toolbar-field datum-field" floatLabel="always">
            <mat-label>Einstalldatum</mat-label>
            <input
              matInput
              [matDatepicker]="datumPicker"
              [ngModel]="datum"
              (ngModelChange)="onEinstalldatumModelChange($event)"
            />
            <mat-datepicker-toggle matSuffix [for]="datumPicker"></mat-datepicker-toggle>
            <mat-datepicker #datumPicker (closed)="onEinstalldatumPickerClosed()"></mat-datepicker>
          </mat-form-field>
        </ng-template>
      </div>

      <p class="scan-hint" *ngIf="scanHinweis">{{ scanHinweis }}</p>

      <div class="sammel-main" *ngIf="aktuell as t">
        <div class="col-left">
          <div class="geschlecht">
            <button
              mat-stroked-button
              type="button"
              [class.active]="t.geschlecht === 'w'"
              (click)="setGeschlecht('w')"
            >
              ♀
            </button>
            <button
              mat-stroked-button
              type="button"
              [class.active]="t.geschlecht === 'm'"
              (click)="setGeschlecht('m')"
            >
              ♂
            </button>
          </div>
          <div class="gewicht-display">{{ t.gewicht || '—' }} <span>kg</span></div>
          <div class="gewicht-pad">
            <button mat-stroked-button type="button" *ngFor="let k of ['1','2','3','4','5','6','7','8','9','.','0','⌫']" (click)="tippeGewichtKey(k)">
              {{ k }}
            </button>
          </div>
        </div>

        <div class="col-center">
          <div class="chip-block">
            <div class="chip-label">Abteil</div>
            <div class="chips">
              <button
                mat-stroked-button
                type="button"
                *ngFor="let a of abteilShortcuts"
                [class.active]="t.abteil === a"
                (click)="toggleChip('abteil', a)"
              >
                {{ a }}
              </button>
              <button
                type="button"
                class="chip-more"
                mat-stroked-button
                aria-label="Mehr Abteil"
                (click)="openMoreAbteil()"
              >
                <mat-icon>add</mat-icon>
              </button>
            </div>
          </div>
          <div class="chip-block">
            <div class="chip-label">Händler</div>
            <div class="chips">
              <button
                mat-stroked-button
                type="button"
                *ngFor="let h of haendlerShortcuts"
                [class.active]="t.haendler === h"
                (click)="toggleChip('haendler', h)"
              >
                {{ h }}
              </button>
              <button
                type="button"
                class="chip-more"
                mat-stroked-button
                aria-label="Mehr Händler"
                (click)="openMoreHaendler()"
              >
                <mat-icon>add</mat-icon>
              </button>
            </div>
          </div>
          <div class="chip-block">
            <div class="chip-label">Herkunft</div>
            <div class="chips">
              <button
                mat-stroked-button
                type="button"
                *ngFor="let h of herkunftAnzeige"
                [class.active]="t.herkunft === h"
                (click)="toggleChip('herkunft', h)"
              >
                {{ h }}
              </button>
              <button
                type="button"
                class="chip-more"
                mat-stroked-button
                aria-label="Mehr Herkunft"
                (click)="openMoreHerkunft()"
              >
                <mat-icon>add</mat-icon>
              </button>
            </div>
          </div>
          <div class="chip-block">
            <div class="chip-label">Bemerkung</div>
            <div class="chips">
              <button
                mat-stroked-button
                type="button"
                *ngFor="let b of bemerkungShortcuts"
                [class.active]="t.bemerkungen.includes(b)"
                (click)="toggleMulti('bemerkungen', b)"
              >
                {{ b }}
              </button>
              <button
                type="button"
                class="chip-more"
                mat-stroked-button
                aria-label="Mehr Bemerkung"
                (click)="openMoreBemerkung()"
              >
                <mat-icon>add</mat-icon>
              </button>
            </div>
          </div>
          <div class="chip-block">
            <div class="chip-label">Reklamation</div>
            <div class="chips">
              <button
                mat-stroked-button
                type="button"
                *ngFor="let r of reklamationShortcuts"
                [class.active]="t.reklamationen.includes(r)"
                (click)="toggleMulti('reklamationen', r)"
              >
                {{ r }}
              </button>
              <button
                type="button"
                class="chip-more"
                mat-stroked-button
                aria-label="Mehr Reklamation"
                (click)="openMoreReklamation()"
              >
                <mat-icon>add</mat-icon>
              </button>
            </div>
          </div>
        </div>

        <div class="col-right">
          <div class="session-panels">
            <div class="geprueft-panel">
              <div class="geprueft-title">Geprüft ({{ geprueft.length }})</div>
              <div class="geprueft-list">
                <div class="geprueft-row" *ngFor="let g of geprueft | slice:0:40">
                  <span class="ohr">{{ g.ohrmarke }}</span>
                  <span class="meta">{{ g.gewicht || '—' }} kg · {{ g.abteil || '—' }}</span>
                  <mat-icon class="ok" *ngIf="g.saved">check_circle</mat-icon>
                  <mat-icon class="warn" *ngIf="!g.saved">pending</mat-icon>
                </div>
                <div class="geprueft-empty" *ngIf="!geprueft.length">Noch keine Tiere geprüft.</div>
              </div>
            </div>

            <div class="geprueft-panel nicht-gefunden-panel">
              <div class="geprueft-title">Nicht gefunden ({{ nichtGefunden.length }})</div>
              <div class="geprueft-list">
                <div class="geprueft-row" *ngFor="let g of nichtGefunden | slice:0:40">
                  <span class="ohr">{{ g.ohrmarke }}</span>
                  <span class="meta">{{ g.gewicht || '—' }} kg · {{ g.abteil || '—' }}</span>
                  <button
                    mat-icon-button
                    type="button"
                    class="row-remove"
                    aria-label="Entfernen"
                    (click)="removeNichtGefunden(g.ohrmarke)"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
                <div class="geprueft-empty" *ngIf="!nichtGefunden.length">
                  Unbekannte Ohrmarken erscheinen hier.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="sammel-idle" *ngIf="!aktuell">
        <div class="idle-prompt" (click)="focusScan()">
          <mat-icon class="idle-icon">qr_code_scanner</mat-icon>
          <div class="idle-copy">
            <strong>Bereit zum Scannen</strong>
            <span>Ohrmarke (10) oder Pass (15) scannen bzw. eingeben.</span>
          </div>
        </div>

        <div class="session-panels idle-session">
          <div class="geprueft-panel idle-geprueft">
            <div class="geprueft-title">Geprüft ({{ geprueft.length }})</div>
            <div class="geprueft-list">
              <div class="geprueft-row" *ngFor="let g of geprueft | slice:0:40">
                <span class="ohr">{{ g.ohrmarke }}</span>
                <span class="meta">{{ g.gewicht || '—' }} kg · {{ g.abteil || '—' }}</span>
                <mat-icon class="ok" *ngIf="g.saved">check_circle</mat-icon>
                <mat-icon class="warn" *ngIf="!g.saved">pending</mat-icon>
              </div>
              <div class="geprueft-empty" *ngIf="!geprueft.length">
                Geprüfte Tiere erscheinen hier nach „Geprüft, nächstes Tier“.
              </div>
            </div>
          </div>

          <div class="geprueft-panel idle-geprueft nicht-gefunden-panel">
            <div class="geprueft-title">Nicht gefunden ({{ nichtGefunden.length }})</div>
            <div class="geprueft-list">
              <div class="geprueft-row" *ngFor="let g of nichtGefunden | slice:0:40">
                <span class="ohr">{{ g.ohrmarke }}</span>
                <span class="meta">{{ g.gewicht || '—' }} kg · {{ g.abteil || '—' }}</span>
                <button
                  mat-icon-button
                  type="button"
                  class="row-remove"
                  aria-label="Entfernen"
                  (click)="removeNichtGefunden(g.ohrmarke)"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </div>
              <div class="geprueft-empty" *ngIf="!nichtGefunden.length">
                Unbekannte Ohrmarken erscheinen hier – danach „Einstallen“.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div mat-dialog-actions class="sammel-actions">
      <button mat-stroked-button type="button" (click)="close()">Schließen</button>
      <button
        mat-stroked-button
        color="primary"
        type="button"
        [disabled]="!canOpenEinstallen || saving"
        (click)="openEinstallen()"
      >
        Einstallen ({{ nichtGefundenHandoffCount }})
      </button>
      <button
        mat-flat-button
        color="primary"
        type="button"
        [disabled]="!aktuell || saving"
        (click)="uebernehmen()"
      >
        {{ saving ? 'Speichern…' : 'Geprüft, nächstes Tier' }}
      </button>
    </div>
  </ng-container>
</div>
